import { NgModule } from '@angular/core';

import { MaterialModule } from 'src/modules/shared/modules/material.module';
import { SharedModule } from 'src/modules/shared/modules/shared.module';
import { PopupModule } from '../base-popup/popup.module';
import { ShareWarningPopupComponent } from './share-warning.component';

@NgModule({
  imports: [
    SharedModule,
    MaterialModule,
    PopupModule
  ],
  declarations: [
    ShareWarningPopupComponent
  ],
  exports: [
    ShareWarningPopupComponent
  ]
})

export class ShareWarningPopupModule {}
